.indicator {
  background-color: light-dark(var(--mantine-color-secondary-1), var(--mantine-color-secondary-6));
  opacity: 1;
  transition: width 250ms ease;
  width: 8px;
  height: 8px;
}

.indicator[data-active] {
  background-color: light-dark(var(--mantine-color-primary-6), var(--mantine-color-primary-5));
  width: 28px;
}

.slide {
  cursor: grab;
  user-select: none;
}

.controls {
  bottom: 0;
  top: auto;
}

.control {
  background-color: var(--mantine-color-primary-light);
  border-width: 0;
  box-shadow: none;
  color: var(--mantine-color-primary-filled);

  transition: all 250ms ease;
}

.control:hover {
  background-color: var(--mantine-color-primary-light-hover);
}

.control[data-inactive] {
  background-color: light-dark(var(--mantine-color-secondary-1), var(--mantine-color-secondary-6));
  color: var(--mantine-color-black);
  cursor: auto;
}
